export default "__VITE_ASSET__DBdI6v6P__"